/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// eslint-disable-next-line jsx-a11y/no-static-element-interactions
import { styled } from '@mui/system';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { style } from '@/styles/globals';
import { pr } from '@/utils/pxToRem';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Grid, Typography } from '@mui/material';
import Link from 'next/link';
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import Image from '@/containers/SearchFlightTabVcms/Image';
import { useRouter } from 'next/router';
import { ILangObj } from '@/slices/goyoloSeo/sliceType';
import { SEO_PAGE_TYPE } from '@/utils/constants';

interface Props {
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window?: () => Window;
  lang?: ILangObj;
  airport?: any;
  pageType?: number,
}
const drawerWidth = 240;

const WrapperHeader = styled('div')`
`;
const navItems = [{
  title: '',
  listItem: [
    {
      image: 'https://storage.googleapis.com/fe-production/svgIcon/home.svg',
      title: 'Trang chủ',
      url: 'https://vexere.com/',
    },
    {
      image: 'https://storage.googleapis.com/fe-production/svgIcon/login.svg',
      title: 'Đăng nhập/ Đăng ký',
      url: 'https://vexere.com/vi-VN/tai-khoan/dang-nhap',
    },
    {
      image: 'https://storage.googleapis.com/fe-production/svgIcon/receipt_long.svg',
      title: 'Quản lý vé',
      url: 'https://vexere.com/vi-VN/ve-cua-toi',
    },
    {
      image: 'https://storage.googleapis.com/fe-production/svgIcon/directions_bus.svg',
      title: 'Thuê xe',
      url: 'https://vexere.com/vn/thue-xe/',
    },
    {
      image: 'https://storage.googleapis.com/fe-production/svgIcon/get_app.svg',
      title: 'Tải app VeXeRe',
      url: 'https://preview.page.link/vexere.page.link/mobile',
    },
    {
      image: 'https://storage.googleapis.com/fe-production/svgIcon/card_giftcard.svg',
      title: 'Khám phá ưu đãi',
      url: 'https://vexere.com/khuyen-mai/',
    },
  ],
},
{
  title: 'Hợp tác cùng VeXeRe',
  listItem: [{
    image: 'https://storage.googleapis.com/fe-production/svgIcon/shake-hand.svg',
    title: 'Mở bán tại VeXeRe',
    url: 'https://bms.vexere.com/mo-ban-ve-tren-vexere-com?utm_source=vex&utm_medium=header&utme_campaign=referral',
  },
  {
    image: 'https://storage.googleapis.com/fe-production/svgIcon/home_work.svg',
    title: 'Phần mềm nhà xe',
    url: 'https://bms.vexere.com/phan-mem-nha-xe',
  },
  {
    image: 'https://storage.googleapis.com/fe-production/svgIcon/store.svg',
    title: 'Phần mềm đại lý',
    url: 'https://daily.vexere.com/',
  }],
},
{
  title: 'Về VeXeRe',
  listItem: [{
    image: 'https://storage.googleapis.com/fe-production/svgIcon/rss_feed.svg',
    title: 'Vexere Blog',
    url: 'https://blog.vexere.com/?_ga=2.147848247.1656112415.1543807326-1211520078.1507173519',
  },
  {
    image: 'https://storage.googleapis.com/fe-production/svgIcon/work_outline.svg',
    title: 'Tuyển dụng',
    url: 'https://careers.vexere.com/',
  }],
},
{
  title: 'Hỗ trợ',
  listItem: [{
    image: 'https://storage.googleapis.com/fe-production/svgIcon/contact-nav.svg',
    title: 'Liên hệ',
    url: '',
  },
  {
    image: 'https://storage.googleapis.com/fe-production/svgIcon/help_outline.svg',
    title: 'Câu hỏi thường gặp',
    url: 'https://vexere.com/vi-VN/nhung-cau-hoi-thuong-gap.html',
  }, {
    image: 'https://storage.googleapis.com/fe-production/svgIcon/policy.svg',
    title: 'Quy chế',
    url: 'https://vexere.com/vi-VN/quy-che',
  }, {
    image: 'https://storage.googleapis.com/fe-production/svgIcon/lock.svg',
    title: 'Chính sách bảo mật thông tin',
    url: 'https://vexere.com/vi-VN/chinh-sach-bao-mat',
  }, {
    image: 'https://storage.googleapis.com/fe-production/svgIcon/payment.svg',
    title: 'Chính sách bảo mật thanh toán',
    url: 'https://vexere.com/vi-VN/chinh-sach-bao-mat-thanh-toan',
  }, {
    image: 'https://storage.googleapis.com/fe-production/svgIcon/speaker_notes.svg',
    title: 'Chính sách và quy trình giải quyết tranh chấp, khiếu nại',
    url: 'https://vexere.com/vi-VN/chinh-sach-va-quy-trinh-giai-quyet-tranh-chap-khieu-nai',
  }],
}];
const MenuItem = styled(Typography)`
  padding: 12px 0px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-left: 20px;
`;

const MenuItemTitle = styled(Typography)`
  padding: 16px 0px 4px;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  font-weight: 600;
`;

const ListItemButton = styled('a')`
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0px;
  display: flex;
  flex-direction: row;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: start;
  justify-content: flex-start;
  text-decoration: none;
`;

const Header = (props: Props) => {
  const {
    window, lang, airport, pageType,
  } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const router = useRouter();
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const [langObj, setLangObj] = React.useState({
    lang: 'vi',
    viUrl: '',
    enUrl: '',
  });
  let airportLocaleNext = (airport?.localizations?.data || []).find((a: { locale: string | undefined; }) => a?.locale !== lang?.lang)?.attributes?.slug;
  let airportLocale = airport?.slug;
  airportLocale = airportLocale?.replace('.en', '');
  airportLocaleNext = airportLocaleNext?.replace('.en', '');
  React.useEffect(() => {
    if (lang?.lang !== 'en') {
      const viUrl = router.asPath;
      const enUrl = viUrl.replace('ve-may-bay', 'flights').replace('-tu-', '-from-').replace('-di-', '-to-').replace('.vi', '.en')
        .replace(airportLocale, airportLocaleNext);
      setLangObj({
        lang: 'VN',
        viUrl,
        enUrl,
      });
    } else {
      const enUrl = router.asPath;
      const viUrl = enUrl.replace('flights', 've-may-bay').replace('-from-', '-tu-').replace('-to-', '-di-').replace('.en', '.vi')
        .replace(airportLocale, airportLocaleNext);
      setLangObj({
        lang: 'EN',
        viUrl,
        enUrl,
      });
    }
  }, []);

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{
        marginTop: '32px',
        padding: '0px 20px 250px',
      }}
    >
      {(!airportLocaleNext && pageType === SEO_PAGE_TYPE.AIRPORT_PAGE) ? null : (
        <Grid
          container
          direction="row"
        >
          <Grid
            item
            direction="row"
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <ListItemButton href={langObj.viUrl}>
              <Image
                imageSrc="https://storage.googleapis.com/fe-production/svgIcon/vn-flag.svg"
                imageProps={{
                  width: 24,
                  height: 18,
                }}
              />
              <MenuItem sx={{
                marginLeft: '20px',
                color: langObj.lang === 'VN' ? 'rgb(36, 116, 229)' : '#484848',
              }}
              >
                Tiếng Việt
              </MenuItem>
            </ListItemButton>

          </Grid>
          <Grid
            item
            direction="row"
            xs={6}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-start',
              alignItems: 'center',
            }}
          >
            <ListItemButton href={langObj.enUrl}>
              <Image
                imageSrc="https://storage.googleapis.com/goyolo-uat/images/en-flag.webp"
                alt="en-flag"
                imageProps={{
                  width: 24,
                  height: 18,
                }}
              />
              <MenuItem sx={{
                marginLeft: '20px',
                color: langObj.lang === 'EN' ? 'rgb(36, 116, 229)' : '#484848',
              }}
              >
                English
              </MenuItem>
            </ListItemButton>
          </Grid>
        </Grid>
      )}
      <Stack>
        {lang?.menuMobile?.map((item) => (
          <Stack key={item.title}>
            <MenuItemTitle>{item.title}</MenuItemTitle>
            {item.children?.map((menuItem) => (
              <ListItemButton
                key={menuItem.title}
                href={menuItem.link}
              >
                <Image
                  imageSrc={menuItem.logo}
                  imageProps={{
                    width: 24,
                    height: 24,
                  }}
                />
                <MenuItem>{menuItem.title}</MenuItem>
              </ListItemButton>
            ))}
          </Stack>
        ))}
      </Stack>
    </Box>
  );

  const container = window !== undefined ? () => window().document.body : undefined;

  return (
    <Box sx={{
      backgroundColor: style.primary.blue,
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.06)',
      zIndex: 1,
      width: '100%',
    }}
    >
      <Container>
        <Box>
          <Box component="nav">
            <Drawer
              container={container}
              variant="temporary"
              open={mobileOpen}
              onClose={handleDrawerToggle}
              ModalProps={{
                keepMounted: true, // Better open performance on mobile.
              }}
              sx={{
                fontFamily: 'SVN-Circular, Roboto',
                position: 'inherit !important',
                top: '56px !important',
                display: {
                  xs: 'block',
                },
                '& .MuiDrawer-paper': {
                  boxSizing: 'border-box',
                  width: '100%',
                  // position: 'inherit !important',
                  top: '56px !important',
                },
              }}
            >
              {drawer}
            </Drawer>
          </Box>
        </Box>
        <Stack
          sx={{
            background: style.primary.blue,
            // padding: '0 20px',
          }}
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Stack
            sx={{
              background: style.primary.blue,
              height: '56px',
              padding: '0 20px',
            }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            {' '}
            <IconButton
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawerToggle}
              sx={{
                color: 'white',
                mr: 2,
              }}
            >
              <MenuIcon />
            </IconButton>
            <WrapperHeader>

              <div
                className="lazyload"
                style={{
                  height: pr`26px`,
                }}
              >
                <Link href={process.env.GOYOLO_URL || '/'}>
                  <Image
                    imageSrc={process.env.NEXT_PUBLIC_VEX_LOGO_LINK || ''}
                    alt="logo"
                    imageProps={{
                      width: 108,
                      height: 24,
                    }}
                  />
                </Link>
              </div>
            </WrapperHeader>

          </Stack>

          <Stack
            sx={{ color: style.neutral.white }}
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography sx={{
              fontWeight: '500',
              fontSize: '16px',
              lineHeight: '24px',
              color: style.neutral.white,
            }}
            >
              {lang?.global?.login}
            </Typography>
            <ChevronRightIcon />
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Header;
